import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import AsyncSearchSelect from '../AsyncSearchSelect';
import { fetchCitiesByCounty } from '../../../../containers/CreationForms/AddEditWorkkard/store/addressApi';
import { useAddressSiblings } from '../utils/addressKeys';
import { getSectionFromKey, getAddressPlaceholder } from '../utils/addressLabels';

function normalizeCities(response) {
  const items = response?.suggestion || response?.data || [];
  return items
    .filter((i) => i && i.city)
    .map((i) => ({ value: i.city, label: i.city }));
}

function CityAsyncField({ config, value, onChange, onBlur, disabled, required, error }) {
  const { watch } = useFormContext();

  const section = useMemo(() => getSectionFromKey(config.fieldKey), [config.fieldKey]);
  const { countyKey, zipKey } = useAddressSiblings(config.fieldKey);

  const county = watch(countyKey);
  const zip = watch(zipKey);

  const placeholder = useMemo(
    () => config?.fieldSettings?.placeholder || getAddressPlaceholder({ role: 'city', section }),
    [config, section]
  );

  const fetchOptions = useMemo(() => {
    return async (q) => {
      try {
        const response = await fetchCitiesByCounty({ county: county || '', q });
        return normalizeCities(response);
      } catch (err) {
        console.error('[CityAsyncField] fetch failed:', err);
        return [];
      }
    };
  }, [county]);


  return (
    <AsyncSearchSelect
      config={config}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled || !zip}
      required={required}
      error={error}
      fetchOptions={fetchOptions}
      placeholder={placeholder}
      minChars={0}
      debounceMs={250}
      allowFreeText
    />
  );
}

export default CityAsyncField;
